import { EmailFastOutlineIcon } from './EmailFastOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 8A3DDFE7-F2D8-47F1-8FFB-2B0C2145CE60
 * name email-fast-outline
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/email-fast-outline.svg
 * tags
 */
export const EmailSendOutlineIcon = EmailFastOutlineIcon;
export default EmailSendOutlineIcon